var map = {
	"./ar/posts/BlogPage.vue": [
		724,
		724
	],
	"./en/posts/BlogPage.vue": [
		7056,
		56
	],
	"./fa/posts/BlogPage.vue": [
		5347,
		347
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 1487;
module.exports = webpackAsyncContext;